export enum CustomerTypes {
    Residential = 1,
    Commercial = 2,
    MunicipalityGovernment = 3,
    SubContracting = 4,
    ResidentialQuoteVerbiage = 13,
    NonResidentialQuoteVerbiage = 14,
  }
